export const ZIP_CODE_REG = /^\d{0,5}$/;
